import { getTimezoneOffset } from "date-fns-tz";

/**
 * @param {string} datestring - The date string (e.g. 2023-01-02)
 * @returns {Date} A new Date object representing date in the user's local timezone (system settings).
 */
export const newDateWithCurrentTimezone = (datestring: string) => {
  const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const offset = getTimezoneOffset(currentTimezone, new Date(datestring));
  const d = new Date(datestring).getTime();
  return new Date(d - offset);
};

// Function to convert input to a Date object at 00:00 in user's local timezone
export const ensureIsDate = <T = unknown, K = undefined>(
  maybeDate: T,
  fallback?: K
) => {
  if (maybeDate instanceof Date) {
    // If the input is already a Date object, use it as is
    return maybeDate;
  }

  const date = newDateWithCurrentTimezone(maybeDate as string);

  //return fallback if date was not successfully parsed
  if (isNaN(date.getTime())) {
    return fallback;
  }

  // otherwise, convert the date string to a Date object in the current system's timezone
  return date;
};
